import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ConfigurationService} from '../../configuration.service';
import {UrlEndpoints} from '../../../definitions/url-endpoints';
import { SimpleEngineerBeanModel } from 'src/app/models/simple-engineer-bean.model';

@Injectable({
    providedIn: 'root'
})
export class JobListService {

    constructor(private http: HttpClient,
                private configuration: ConfigurationService,
                private urlEndpoints: UrlEndpoints) {
    }

    getJobStatusList() {
        return this.http.get(this.configuration.buildUrl(this.urlEndpoints.jobStatusListEndPoint)).toPromise();
    }

    getJobTypeList() {
        return this.http.get(this.configuration.buildUrl(this.urlEndpoints.wsJobTypeListEndPoint)).toPromise();
    }

    getJobList() {
        return this.http.get(this.configuration.buildUrl(this.urlEndpoints.serviceJobListEndPoint)).toPromise();
    }

    getMeterReadingTypes() {
        return this.http.get(this.configuration.buildUrl(this.urlEndpoints.meterTypeListEndPoint)).toPromise();
    }

    getMeterMandatoryReading() {
        return this.http.get(this.configuration.buildUrl(this.urlEndpoints.getWsJobTemplateToWsNamedMeterBeansEndPoint)).toPromise();
    }

    getJobCertificates() {
        return this.http.get(this.configuration.buildUrl(this.urlEndpoints.jobCertificateTextEndPoint)).toPromise();
    }

    getJobTemplate() {
        return this.http.get(this.configuration.buildUrl(this.urlEndpoints.jobTemplateEndPoint)).toPromise();
    }

    getTasksList() {
        return this.http.get(this.configuration.buildUrl(this.urlEndpoints.wsTasksEndPoint)).toPromise();
    }

    getJobHistory(id) {
        return this.http.get(this.configuration.buildUrl(this.urlEndpoints.jobHistoryEndPoint + id)).toPromise();
    }

    postJobStatusUpdate(jobId, jobStatusId){
        console.log('Job id = ' + jobId + ' job_status_id = ' + jobStatusId );
        return this.http.post(this.configuration.buildUrl(this.urlEndpoints.jobStatusUpdateEndPoint),{key: jobId , value: jobStatusId }).toPromise();
    }

    postEngineerSignature(simpleEngineerBeanModel: SimpleEngineerBeanModel){

        const cleanWorkerBeanObj = { 'id' : simpleEngineerBeanModel.id ,
         'name' : simpleEngineerBeanModel.name , 'signature_base64' : simpleEngineerBeanModel.signature_base64 }
        return this.http.post(this.configuration.buildUrl( this.urlEndpoints.engineerSignatureUpdateEndPoint ), cleanWorkerBeanObj ).toPromise();
    }

}
